/**
 * Typed navigation actions for ported OEM+ narrative seeds.
 *
 * The source demo (`OEM+_Platform_Demo.html`) wires every cross-reference as an
 * inline handler string — `onclick="show('machine','L-02')"`. Those strings are
 * not portable to React and are rejected by
 * `scripts/oem/check-no-handler-strings.mjs`. Every such reference in a seed is
 * therefore carried as a structured `OemAction` and resolved to a route by
 * `oem-routes.ts` (owned by the chrome lane).
 *
 * Data Schema layer — type shapes only, no behaviour.
 * @see docs/foundations/4-layer-architecture.md
 */

/** A demo `show(view, sub)` call, captured as data. */
export interface OemAction {
  /** First argument of the demo's `show()` — the view key, e.g. `'machine'`. */
  view: string;
  /** Second argument, when present — the view's argument, e.g. a machine id. */
  sub?: string;
}

/** Convenience constructor keeping seed files terse. */
export const act = (view: string, sub?: string): OemAction =>
  sub === undefined ? { view } : { view, sub };
